import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Adicionar timeout para evitar requisições que ficam pendentes
api.defaults.timeout = 30000; // 30 segundos

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log detalhado para debug
    if (error.response) {
      // Erro com resposta do servidor
      console.error('Erro na API:', {
        url: error.config?.url,
        status: error.response.status,
        data: error.response.data,
        message: error.message,
      });
    } else if (error.request) {
      // Erro de rede (sem resposta do servidor)
      console.error('Erro de rede:', {
        url: error.config?.url,
        message: error.message,
        code: error.code,
      });
      
      // Se for erro de conexão recusada, adicionar mensagem mais clara
      if (error.code === 'ERR_NETWORK' || error.code === 'ERR_CONNECTION_REFUSED') {
        console.error('⚠️ Backend não está rodando! Inicie o servidor Flask na porta 5000.');
        // Adicionar mensagem customizada ao erro
        error.userMessage = 'Servidor não está disponível. Verifique se o backend está rodando na porta 5000.';
      }
      
      // Se for erro de conexão recusada, mostrar mensagem mais clara
      if (error.code === 'ERR_NETWORK' || error.code === 'ERR_CONNECTION_REFUSED') {
        console.error('⚠️ Backend não está rodando! Inicie o servidor Flask na porta 5000.');
        // Não deslogar por erro de conexão - pode ser temporário
        return Promise.reject({
          ...error,
          userMessage: 'Servidor não está disponível. Verifique se o backend está rodando na porta 5000.'
        });
      }
    } else {
      // Outro tipo de erro
      console.error('Erro na requisição:', error.message);
    }

    // Apenas deslogar se for erro 401 e não for a rota /auth/me (para evitar loop)
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Não redirecionar imediatamente se for a rota de verificação de auth
      // O AuthContext já trata isso
      if (!url.includes('/auth/me')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // Usar replace para evitar adicionar ao histórico
        if (window.location.pathname !== '/login') {
          window.location.replace('/login');
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
